import {format} from 'date-fns/format';

const isIos = /ip(?:ad|od|hone)/u.test(navigator.userAgent.toLowerCase());

const fromField = document.querySelector<HTMLInputElement>('#from');
const toField = document.querySelector<HTMLInputElement>('#to');

// Set correct minimum values for date inputs.
if (fromField && toField) {
	fromField.value = fromField.value === '' ? fromField.min : fromField.value;

	if (toField.value === '' && isIos) {
		toField.value = fromField.min;
	}

	fromField.addEventListener('input', () => {
		const {value} = fromField;
		if (value.trim() !== '') {
			toField.min = format(new Date(value), 'yyyy-MM-dd');
		}
	});
}
